/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Passenger basic data (first name, last name, birthdate)
 * @export
 * @interface PaxCheckPax
 */
export interface PaxCheckPax {
    /**
     * Given names, should be provided if last_name is null
     * @type {string}
     * @memberof PaxCheckPax
     */
    firstName?: string | null;
    /**
     * Last name, should be provided if first_name is null
     * @type {string}
     * @memberof PaxCheckPax
     */
    lastName?: string | null;
    /**
     * Birthdate, if set in DCS
     * @type {Date}
     * @memberof PaxCheckPax
     */
    birthdate?: Date | null;
}

/**
 * Check if a given object implements the PaxCheckPax interface.
 */
export function instanceOfPaxCheckPax(value: object): value is PaxCheckPax {
    return true;
}

export function PaxCheckPaxFromJSON(json: any): PaxCheckPax {
    return PaxCheckPaxFromJSONTyped(json, false);
}

export function PaxCheckPaxFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckPax {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'birthdate': json['birthdate'] == null ? undefined : (new Date(json['birthdate'])),
    };
}

export function PaxCheckPaxToJSON(json: any): PaxCheckPax {
    return PaxCheckPaxToJSONTyped(json, false);
}

export function PaxCheckPaxToJSONTyped(value?: PaxCheckPax | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'birthdate': value['birthdate'] == null ? undefined : ((value['birthdate'] as any).toISOString().substring(0,10)),
    };
}

